import React from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";

const Signup = () => {
  return (
    <div>
      <div className="container lg:w-1/2 mx-auto py-5">
        <div className="bg-gradient-to-r to-[#f59a61] from-[#f5695d] text-gray-500 rounded-3xl shadow-xl w-full overflow-hidden">
          <div className="flex justify-center w-full">
            <div className="flex-row justify-center items-center py-5 px-5 md:px-10">
              <div className="text-center mb-3">
                <h1 className="font-bold text-3xl text-gray-700">REGISTER</h1>
                <p className="text-gray-700">
                  Enter your information to register
                </p>
              </div>
              <form>
                <div>
                  <div className="flex -mx-3">
                    <div className="w-1/2 px-3 mb-3">
                      <label
                        for="first-name"
                        className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                      >
                        First name
                      </label>
                      <div className="flex">
                        <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                          <BsFillPersonFill className="mdi mdi-account-outline text-gray-400 text-lg" />
                        </div>
                        <input
                          type="text"
                          className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                          required
                          placeholder="John"
                        />
                      </div>
                    </div>
                    <div className="w-1/2 px-3 mb-3">
                      <label
                        for="last-name"
                        className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                      >
                        Last name
                      </label>
                      <div className="flex">
                        <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                          <BsFillPersonFill className="mdi mdi-account-outline text-gray-400 text-lg" />
                        </div>
                        <input
                          type="text"
                          className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                          required
                          placeholder="Smith"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex -mx-3">
                    <div className="w-full px-3 mb-3">
                      <label
                        for="s-mail"
                        className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                      >
                        Email
                      </label>
                      <div className="flex">
                        <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                          <MdEmail className="mdi mdi-account-outline text-gray-400 text-lg" />
                        </div>
                        <input
                          type="email"
                          className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                          required
                          placeholder="johnsmith@example.com"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex -mx-3">
                    <div className="w-full px-3 mb-3">
                      <label
                        for="password"
                        className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                      >
                        Password
                      </label>
                      <div className="flex">
                        <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                          <RiLockPasswordFill className="mdi mdi-account-outline text-gray-400 text-lg" />
                        </div>
                        <input
                          type="password"
                          className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                          required
                          placeholder="************"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex -mx-3">
                    <div className="w-full px-3">
                      <button className="block w-full max-w-xs mx-auto bg-btn-sec hover:bg-nav-gradient-from focus:bg-nav-gradient-from text-white rounded-lg px-3 py-3 font-semibold">
                        REGISTER NOW
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
